import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';

import { MenuItem } from './menu.model';
import { MENU } from './menu';
import { MENU_PLATAFORMA } from './menu-plataforma';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  lastroute: any;

  constructor(private router: Router, public translate: TranslateService, private authenticationService: AuthenticationService) {
    translate.setDefaultLang('sp');
  }

  ngOnInit(): void {
    // Menu Items, filtrados por rol (ver MenuItem.roles en menu.model.ts).
    this.aplicarMenuSegunRol();
    this.authenticationService.claimsChanged$.subscribe(() => this.aplicarMenuSegunRol());

    this.router.events.subscribe((event) => {
      if (document.documentElement.getAttribute('data-layout') == 'vertical' || document.documentElement.getAttribute('data-layout') == 'horizontal') {
        if (event instanceof NavigationEnd) {
          this.initActiveMenu();
          this.SidebarHide();
        }
      }
    });
  }

  private aplicarMenuSegunRol(): void {
    this.authenticationService.currentClaims().then((claims) => {
      const rol = claims?.rol;
      // super_admin es un rol global de FuturaPro (no pertenece a ninguna
      // empresa) y usa un menú completamente separado — nunca se mezcla
      // con el menú de tenant, así que ese array ni se filtra por roles.
      if (rol === 'super_admin') {
        this.menuItems = MENU_PLATAFORMA;
        return;
      }

      // El admin ve TODO el menú de su empresa sin pasar por permisos (esos
      // son exclusivos del checklist de sub_admin) — muchos subitems (ej.
      // "Ver préstamos") solo llevan `permiso`, sin `roles`, así que sin
      // este atajo el admin quedaba filtrado igual que un sub_admin sin
      // permisos.
      if (rol === 'admin') {
        this.menuItems = MENU;
        return;
      }

      // Un sub_admin no aparece en `roles` de casi ningún ítem (esos son
      // fijos para admin/super_admin) — su acceso depende de los permisos
      // granulares del checklist de /equipo, así que un ítem también se
      // muestra si tiene `permiso` y el sub_admin lo tiene en sus claims
      // (mismo permiso que ya exige el RoleGuard de la ruta destino).
      const permisos = rol === 'sub_admin' ? (claims?.permisos ?? []) : [];
      const puedeVer = (item: MenuItem): boolean => {
        if (!item.roles && !item.permiso) return true;
        if (!!rol && !!item.roles && item.roles.includes(rol)) return true;
        return !!item.permiso && permisos.includes(item.permiso);
      };

      this.menuItems = MENU
        .map((item): MenuItem => {
          if (!item.subItems) return item;
          return { ...item, subItems: (item.subItems as MenuItem[]).filter(puedeVer) };
        })
        .filter((item) => item.subItems ? (item.subItems as MenuItem[]).length > 0 : puedeVer(item));
    });
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }
  
  toggleItem(event: any,item: any) {
    item.isOpen = !item.isOpen;

    if (item.isOpen) {
      this.menuItems.forEach((menuItem: any) => {
        if (menuItem !== item) {
          menuItem.isOpen = false;
        }
      });
    }

    const isCurrentMenuId = event.target.closest('a.nav-link');
    isCurrentMenuId.setAttribute('aria-expanded', item.isOpen.toString());
  }

  // toggleItem(event: any) {
  //   let isCurrentMenuId = event.target.closest('a.nav-link');
  //   let isMenu = isCurrentMenuId.nextElementSibling as any;
  //   if (isMenu.classList.contains("show")) {
  //     isMenu.classList.remove("show");
  //     isCurrentMenuId.setAttribute("aria-expanded", "false");
  //   } else {
  //     let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
  //     dropDowns.forEach((node: any) => {
  //       node.classList.remove('show');
  //     });
  //     (isMenu) ? isMenu.classList.add('show') : null;
  //     const ul = document.getElementById("navbar-nav");

  //     const pathName = window.location.pathname;
  //     if (ul) {
  //       const items = Array.from(ul.querySelectorAll("a.nav-link"));
  //       let activeItems = items.filter((x: any) => x.classList.contains("active"));
  //       this.removeActivation(activeItems);

  //       let matchingMenuItem = items.find((x: any) => {
  //         return x.pathname === pathName;
  //       });
  //       if (matchingMenuItem) {
  //         this.activateParentDropdown(matchingMenuItem);
  //       }
  //     }

  //     isCurrentMenuId.setAttribute("aria-expanded", "true");
  //     if (isCurrentMenuId) {
  //       this.activateParentDropdown(isCurrentMenuId);
  //     }
  //   }
  // }

  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;

    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });
      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });

      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  // Click wise Parent active class add
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
          parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
            parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }

    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });

      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }


}
